"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStore = void 0;
const react_1 = require("react");
function createStore(handlers, initial) {
    const state = initial;
    const subscribers = new Set();
    const applyDiff = (_a = {}) => {
        var { dispatch } = _a, diff = __rest(_a, ["dispatch"]);
        if (Object.keys(diff).length > 0) {
            Object.entries(diff).forEach(([key, value]) => {
                if (state[key] === value) {
                    delete diff[key];
                }
                if (value === undefined) {
                    delete state[key];
                }
                else {
                    state[key] = value;
                }
            });
            subscribers.forEach((cb) => cb(diff));
        }
    };
    const dispatch = (type, ...data) => {
        const handler = handlers[type];
        if (handler) {
            applyDiff(handler(Object.assign(Object.assign({}, state), { dispatch }), ...data));
        }
    };
    const useStore = (...keys) => {
        const [trigger, rerender] = (0, react_1.useState)({});
        const subscribeKeys = (0, react_1.useRef)();
        const keysString = keys.join('|');
        const cb = (0, react_1.useCallback)((diff) => keys.some((key) => key in diff) && rerender({}), [keysString]);
        (0, react_1.useEffect)(() => () => {
            subscribers.delete(cb);
        }, [cb]);
        if (keysString !== subscribeKeys.current) {
            subscribers.add(cb);
            subscribeKeys.current = keysString;
        }
        return (0, react_1.useMemo)(() => [
            keys.reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: state[key] })), {}),
            dispatch,
        ], [keysString, trigger]);
    };
    useStore.dispatch = dispatch;
    useStore.getState = () => state;
    useStore.setState = (update) => applyDiff(typeof update === 'function' ? update(state) : update);
    return useStore;
}
exports.createStore = createStore;
